import type { OnlineConfig } from '@ael/core-api';
import { getEnvValue } from '../env';

export type ExtendedInlineConfig = OnlineConfig & {
  BACKEND_URL: string;
  ROOT_URL: string;
  PATH_TO_PUBLIC_FOLDER: string;
  USERNAME: string;
  PASSWORD: string;
};

export function dynamicEnv<K extends keyof ExtendedInlineConfig>(envVar: K): ExtendedInlineConfig[K] | undefined {
  const url = new URL(window.location.href);
  if (url.searchParams.has(envVar)) {
    return url.searchParams.get(envVar) as ExtendedInlineConfig[K];
  }

  /* if (fetchedConfig?.[envVar] !== undefined) {
       return fetchedConfig?.[envVar];
     }*/

  if (window?.inlineConfig?.[envVar] !== undefined) {
    return window?.inlineConfig?.[envVar];
  }

  const envValue = getEnvValue(envVar);
  if (envValue !== undefined) {
    return envValue as ExtendedInlineConfig[K];
  }

  return undefined;
}
